export default __webpack_public_path__ + "1f8a09ce984df6bb9c38999639e07ff7.png";